export default __webpack_public_path__ + "static/media/radial_2.fe9b8f90.png";